import { ReactNode } from 'react';

import { Box } from 'components/Box';
import { AnimatedCheckmark } from 'components/Icon/AnimatedCheckmark';
import { Body } from 'components/Text/Body';
import { TabContext } from 'containers/TabContext';

import {
  CheckboxContainer,
  CheckmarkContainer,
  StyledCheckbox,
  StyledLabel,
  Toggle,
  ToggleCheckmarkContainer,
} from './Checkbox.styled';

type Props = {
  'aria-label'?: string;
  'aria-labelledby'?: string;
  'data-qa-id'?: string;
  id?: string;
  name?: string;
  label?: ReactNode;
  placeholder?: string | null | undefined;
  required?: boolean;
  value?: (boolean | null | undefined) | (string | null | undefined);
  checked: boolean;
  hasError?: boolean;
  onChange: (checked: boolean) => void;
  toggle?: boolean;
  disabled?: boolean;
  large?: boolean;
  className?: string;
};

export function Checkbox({
  id,
  name,
  label,
  checked,
  hasError,
  onChange,
  toggle,
  disabled,
  large,
  className,
  value,
  ...props
}: Props) {
  return (
    <CheckboxContainer $hasError={hasError} className={className}>
      {toggle ? (
        <Box
          lineHeight={0}
          position="relative"
          width={40}
          height={24}
          flex="0 0 auto"
        >
          <Toggle $checked={checked} $disabled={disabled}>
            <ToggleCheckmarkContainer>
              {checked && <AnimatedCheckmark size={16} colorName="brandBlue" />}
            </ToggleCheckmarkContainer>
          </Toggle>
        </Box>
      ) : (
        <Box
          position="relative"
          width={large ? 24 : 16}
          height={large ? 24 : 16}
          flex="0 0 auto"
        >
          <CheckmarkContainer
            $checked={checked}
            $disabled={disabled}
            className="checkmark-container"
          >
            {checked && <AnimatedCheckmark size={16} colorName="white" />}
          </CheckmarkContainer>
        </Box>
      )}
      {label && (
        <StyledLabel htmlFor={id}>
          <Body>{label}</Body>
        </StyledLabel>
      )}
      <TabContext.Consumer>
        {(isTabbing) => (
          // @ts-expect-error TS(2769): No overload matches this call.
          <StyledCheckbox
            $isTabbing={isTabbing}
            type="checkbox"
            name={name}
            id={id}
            checked={checked}
            onChange={(e) => {
              e.stopPropagation();
              onChange(e.target.checked);
            }}
            disabled={disabled}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
          />
        )}
      </TabContext.Consumer>
    </CheckboxContainer>
  );
}
